import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,
}